import { nth } from './nth';

export function first<T>(array: T[], defaultValue: T): T | undefined {
  return nth(array || [], 0, defaultValue);
}
